import Link from "next/link";

const HexaLink = ({ to, className, children, onOver, onOut }: any) => {
  if (to.indexOf("http") === 0) {
    return (
      <a
        href={to}
        className={className}
        target="_blank"
        rel="noreferrer"
        onMouseOver={onOver}
        onMouseOut={onOut}
      >
        {children}
      </a>
    );
  }

  return (
    <Link
      href={to}
      className={className}
      onMouseOver={onOver}
      onMouseOut={onOut}
    >
      {children}
    </Link>
  );
};

export default HexaLink;
